module.exports = "<news12-button ng-repeat=\"item in vm.items\"\n               ng-class=\"{selected: vm.selectedIndex === $index, 'focusable-first': !$index, 'focusable-last': $index === vm.items.length - 1}\"\n               badge=\"{{item.badge}}\"\n               on-keydown=\"vm.onKeyDown(event, item)\"\n               on-select=\"vm.select($index)\">\n{{item.title}}</news12-button>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/navbar/navbar.html
 ** module id = 141
 ** module chunks = 0
 **/